/**
 * @desc basic-更新sku信息同步供应商报价
 */
const URL = "/rantion-srm";
import http, { updateResponse } from "@/http";
export function request(body: Array<defs.srm.SupplierQuotationUpdateRequestDto>, options?: any) {
  return updateResponse(
    http(URL + `/updateSkuSupplierQuotation`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
